// Copyright (c) 2025 by Audere

import { Box, Divider, Typography } from "@mui/material";
import { t } from "i18next";
import React from "react";
import {
  AddQCFeedbackRequest,
  LabelingRole,
  UpdateLabelRequest,
} from "../../features/api/labelApiSlice";
import { createStyleSheet } from "../../utils/styles";
import LabelingForm from "./LabelingForm";
import { LabelTask } from "../../features/label/labelTypes";
import { useAppSelector } from "../../features/store";
import { getQCCorrection } from "../../utils/taskUtils";
import { useCurrentUser } from "../../hooks/useCurrentUser";

interface SummaryLabelsProps {
  task: LabelTask;
  debugEnabled?: boolean;
  summary: string;
  onSave: (payload: UpdateLabelRequest | AddQCFeedbackRequest) => void;
}

const SummaryLabels: React.FC<SummaryLabelsProps> = ({
  debugEnabled,
  task,
  summary,
  onSave,
}) => {
  const qcCorrectLabels = useAppSelector(
    (state) => state.label.qcCorrectLabels
  );
  const isCorrect = getQCCorrection(qcCorrectLabels, task.id);
  const { isQC, isMonitor } = useCurrentUser();

  return (
    <Box sx={styles.summaryBox}>
      <Typography variant="h5" gutterBottom>
        {t("conversation.summaryTitle")}
      </Typography>
      <Typography variant="body1">{summary}</Typography>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "space-around" }}>
        <LabelingForm
          task={task}
          debugEnabled={debugEnabled}
          formProvider={LabelingRole.conversation_labeler}
          onSave={onSave}
        />
        {((isCorrect === false && isQC) || isMonitor) && (
          <LabelingForm
            task={task}
            debugEnabled={debugEnabled}
            formProvider={LabelingRole.conversation_label_qc}
            onSave={onSave}
          />
        )}
      </Box>
    </Box>
  );
};

const styles = createStyleSheet({
  summaryBox: {
    borderBottom: "1px solid lightgrey",
    padding: 2,
  },
});

export default SummaryLabels;
